import React, { FunctionComponent, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button, Typography, Slide } from "@material-ui/core";
import "./index.scss";
import {
  enable as enableAnalytics,
  disable as disableAnalytics,
  getEnabled as getAnalyticsEnabled,
} from "services/analytics";
import RouteURLs from "RouteURLs";

export const CookiePopUp: FunctionComponent = () => {
  const [cookieView, setCookieView] = useState(false);

  const onAcceptClick = () => {
    enableAnalytics();
    setCookieView(false);
  };

  const onRejectClick = () => {
    disableAnalytics();
    setCookieView(false);
  };

  useEffect(() => {
    const accepted = getAnalyticsEnabled();
    accepted === null ? setCookieView(true) : setCookieView(false);
  }, []);

  return (
    <>
      {cookieView === true && (
        <Slide direction="down" in={cookieView === true} timeout={500}>
          <div className="cookie-popup">
            <div className="content-mw module-grid">
              <Typography variant="h6" component="h6" className="section-title">
                Cookies on sook.space
              </Typography>
              <Typography variant="body1" className="text">
                We use some essential cookies to make this service work. We’d
                also like to use analytics cookies so we can understand how you
                use the service and make improvements.
              </Typography>
              <div className="actions">
                <Button
                  variant="outlined"
                  size="small"
                  color="primary"
                  onClick={(e) => onRejectClick()}
                >
                  Reject analytics cookies
                </Button>
                <Button
                  variant="contained"
                  size="small"
                  color="primary"
                  onClick={(e) => onAcceptClick()}
                >
                  Accept analytics cookies
                </Button>
                <Link className="cookie-link" to={RouteURLs.COOKIES}>
                  View cookies
                </Link>
              </div>
            </div>
          </div>
        </Slide>
      )}
    </>
  );
};

export default CookiePopUp;
